module.exports = __webpack_public_path__ + "assets/4c86d617bc675e66cd7b0d2c034256c4.png";